<template>
  <div>
    <h4 class="text-primary-dark mb-0 clearfix">
      Documentos
      <upload-documento :tipoObjeto="tipoObjeto" :idObjeto="idObjeto" @uploaded="getDocumentos(false)"/>
    </h4>
    <lista-documentos :documentos="documentos" :loading="loading" @documento-seleccionado="download($event)"/>
  </div>
</template>
<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import util from '@/util'
import Loading from '@/components/widgets/Loading'
import ListaDocumentos from '@/components/widgets/documentos/ListaDocumentos'
import UploadDocumento from '@/components/widgets/documentos/UploadDocumento'
export default {
  data() { 
    return {
      loading: true,
      sortKey: null,
      reverse: false,
      documentos: []
    }
  },
  props: {
    tipoObjeto: {
      default: null
    },
    idObjeto: {
      default: null
    }
  },
  computed: {
    ...mapGetters({
      urlBase: 'urlBase',
      credentials: 'credentials'
    })
  },
  mounted() {
    //this.$store.dispatch("clearDocumentos");
    this.getDocumentos();
  },
  methods: {
    getUrl(archivo) {
      return this.urlBase + 'archivodocumental/' + archivo.id + '?token=' + this.credentials.token;
    },
    download(documento) {
      window.open(this.getUrl(documento));
    },
    getDocumentos(loading) {
      if (loading !== false) {
        this.loading = true;
      }
      let grupos = [
          'archivoDocumental.tipo'
      ]
      let params = {
          'tipoObjeto': this.tipoObjeto,
          'idObjeto': this.idObjeto,
          'grupos': grupos.join(','),
          'sort': 'archivodocumental.fechaCreacion',
          'inverse': true,
          'page': 1
      };

      let url = this.urlBase + 'archivodocumental?' + util.objToQuery(params);
      this.$http.get(url).then(
        (response) => {
          this.documentos = response.body.items

          for(let i = 2; i <= response.body.totalPages; i++){
            params.page = i;
            let url = this.urlBase + 'archivodocumental?' + util.objToQuery(params);
            this.$http.get(url).then(
              (response) => {
                for (let d = 0; d < response.body.items.length; d++) {
                  this.documentos.push(response.body.items[d]);
                }
              },
              (error) => {
                payload.callbackError(error);
              }
            );
          }

          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    }
  },
  components: {
    Loading,
    ListaDocumentos,
    UploadDocumento
  }
}
</script>
<style>
[hidden] {
  display: none !important;
}
</style>
